// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4190":"6180bc1d","5942":"8f5fddf7"}[chunkId] + ".chunk.css";
};